var waitFor = require("../utils/waitFor");
// var selecter = require("../lib/slick");

waitFor("body.page-template-home", function () {
  var $images = $(".home-hero__slides a"),
    curImg = -1;

  function changeImage() {
    var newImg = curImg + 1;

    if (newImg == $images.length) newImg = 0;

    $images.eq(curImg).removeClass("is-visible");
    $images.eq(newImg).addClass("is-visible");

    curImg = newImg;

    setTimeout(changeImage, 3000);
  }

  changeImage();

  // vertically center product info
  var $prodInfo = $(".product-info"),
    $prodImg = $(".product-image");

  function centerProductInfo() {
    var infoH = $prodInfo.height(),
      imgH = $prodImg.height();

    if (infoH < imgH) {
      $prodInfo.css("margin-top", Math.round((imgH - infoH) / 2) - 20);
    } else {
      $prodInfo.css("margin-top", 0);
    }
  }
  $(window).resize(centerProductInfo);
  setTimeout(centerProductInfo, 100);

  // add slick
  $(".home-slider").slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1200,
  });

  // random hero area
  var heroData = window.homeHeroData;
  var slide = heroData[Math.floor(Math.random() * heroData.length)];

  // render slide
  var $homeHero = $(".home-hero-v2");
  var $slide = $('<div class="container" />');

  switch (slide.type) {
    case "product":
      $slide.addClass("home-product");
      $slide.append(
        '<img src="' + slide.image + '" alt="" class="product-image">'
      );

      var $productInfo = $('<div class="product-info" />');
      $productInfo.append('<img src="' + slide.logo + '">');

      var $productCopy = $('<div class="product-copy" />');
      $productCopy
        .append("<h2>" + slide.headline + "</h2>")
        .append(slide.paragraph)
        .append(
          '<a href="' +
            slide.link +
            '" class="button button--blue-light">' +
            slide.label +
            "</a>"
        );

      $productInfo.append($productCopy);
      $slide.append($productInfo);
      break;

    case "photo":
      $slide.addClass("home-photo");
      $homeHero.css("background-image", "url(" + slide.photo + ")");
      var $slideCopy = $('<div class="slide-copy" />');
      $slideCopy
        .append("<h2>" + slide.headline + "</h2>")
        .append(slide.paragraph)
        .append(
          '<a href="' +
            slide.link +
            '" class="button button--blue-light">' +
            slide.label +
            "</a>"
        );

      $slide.append($slideCopy);
      var $socLogo = $(
        '<img class="soc-logo" src="https://www.connectpositronic.com/wp-content/uploads/2018/07/SoC-branding-white.png" alt="The Science of Certainty" />'
      );
      $slide.append($socLogo);
      break;
  }

  $homeHero
    .addClass("type-" + slide.type)
    .append($slide)
    .addClass("loaded");
});
